var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"view-home"}},[_c('HowItWorks',{attrs:{"customItems":_vm.customItems}}),_c('Prizes',{attrs:{"customItems":_vm.customItems}}),_c('BannerApp',{attrs:{"customItems":_vm.customItems}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }